export const localStorageKeys = {
  printMapTiles: 'print-map-tile',
  ign: 'use-ign-tiles',
  state: 'state',
  drivers: 'drivers',
  equipments: 'equipments',
  parcels: 'parcels',
  tracks: 'tracks',
  observations: 'observations',
  parcelsName: 'parcelsName',
  colorizeFieldsBy: 'colorize-fields-by',
  colorizeTracksBy: 'colorize-tracks-by',
  forcePageRefresh: 'page-has-been-force-refreshed',
  showMarkerClusters: 'show-marker-clusters',
  dateRange: 'date-range',
  dateRangeMeta: 'date-range-meta',
  reportEquipmentSort: 'report-equipment-sort',
  taskClientReportSelection: 'task-client-report-selection',
  taskArticleReportSelection: 'task-article-report-selection',
  planningClusterSelection: 'planning-cluster-selection',
  dashboardWorksiteDimension: 'dashboard-worksite-dimension',
  dashboardClusterDimension: 'dashboard-cluster-dimension',
} as const;
